import { render, staticRenderFns } from "./LiveClass.vue?vue&type=template&id=1c95549d&scoped=true"
import script from "./LiveClass.vue?vue&type=script&lang=js"
export * from "./LiveClass.vue?vue&type=script&lang=js"
import style0 from "./LiveClass.vue?vue&type=style&index=0&id=1c95549d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95549d",
  null
  
)

export default component.exports